import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DefaultImg from '../Images/Products/Default.png';

function CategoriesSliderDiv(props) {
    const navigate = useNavigate();

    function navigatetocategory(name) {
        navigate('/search', { state: { name } });
    }

    // DYNAMICALLY IMPORT IMAGES OF CARDS:
    const [img, setImg] = useState(DefaultImg);  // Initialize with DefaultImg
    useEffect(() => {
        // Dynamically import the image using the variable
        import(`../Images/Categories/${props.name}.jpg`)
            .then((image) => setImg(image.default))
            .catch((error) => console.error('Error loading image:', error));
    }, [props.name]);

    return (
        <div className={`CarouselItem CI${(props.index) +1}`} onClick={() => navigatetocategory(props.name)}>
            {props.name}
            <img src={img ? img : DefaultImg} alt={props.name} />
        </div>
    );
}

export default CategoriesSliderDiv;
